module.exports = __webpack_public_path__ + "img/selectOptions.bd06c34d.svg";